import PathCheckerAIHandler from "./path-checker-ai-handler.js";

export default function AIHandler() {
    var pathCheckerAiHandler = PathCheckerAIHandler();

    // `skill` (optional, 1-10) tunes how good this AI plays: higher = looks
    // further ahead, replans more eagerly, blunders less. Omitted/undefined
    // keeps the original (legacy) behaviour, so offline play is unchanged.
    // `cheap` (optional) selects the low-cost preview AI profile (short lookahead,
    // coarse stepping, single candidate, throttled replanning) for decorative
    // lobby previews. Omitted/false = normal play, unchanged.
    // `traits` (optional) is the personality: an object of trait weights (e.g.
    // { caution: 0.4, aggression: 0.3 }) scored against the shared board model.
    // Requires a skill (the board model rides the skilled planning path).
    // See docs/design/bots/PERSONALITIES.md.
    function addAIPlayer(player, skill, cheap, traits) {
        if(player.aiData) {
            throw Error("player.ai is already set: ", player.aiData);
        }

        player.aiData = {};
        if (skill !== undefined && skill !== null) {
            player.aiData.skill = Math.max(1, Math.min(10, skill));
        }
        if (cheap) {
            player.aiData.cheap = true;
        }
        if (traits && typeof traits === "object") {
            player.aiData.traits = traits;
        }
    }

    function removeAIPlayer(player) {
        player.aiData = undefined;
    }

    function update(gameState, deltaTime) {
        // One budget per tick, shared by every bot (limits from the crowd
        // ladder, crowd.js): spreads the optional re-evaluations and the full
        // replans out so a full box doesn't spike on the ticks where many
        // bots' timers line up. Small games have no limits.
        var budget = { reevals: 0, replans: 0 };
        gameState.players.forEach(function (player) {
            if(player.aiData) {
                pathCheckerAiHandler.update(gameState, deltaTime, player, budget);
            }
        });
    }

    return {
        addAIPlayer,
        removeAIPlayer,
        update
    };
};